import { Component, InputSignal, ViewChild, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ButtonModule } from "@openng/optimus-ui/button";
import { ConfirmPopup, ConfirmPopupModule } from "@openng/optimus-ui/confirmpopup";

@Component({
  standalone: true,
  selector: "app-confirm-popup",
  imports: [ConfirmPopupModule, ButtonModule, TranslateModule],
  templateUrl: "./confirm-popup.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./confirm-popup.component.scss",
})
export class ConfirmPopupComponent {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  public key: InputSignal<string | undefined> = input();
  public translate = inject(TranslateService);
  public accept() {
    this.confirmPopup.onAccept();
  }

  public reject() {
    this.confirmPopup.onReject();
  }
}
